import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Container,
  Stack,
  IconButton,
  Grid,
} from "@mui/material";
import { FaShareAlt } from "react-icons/fa";
import refer_img from "../../../../../Assets/referImgeInvite.svg";
// import facebook_icon from "../../../Assets/facebook_icon.svg";
// import whatsapp_icon from "../../../Assets/whatsapp_icon.svg";
// import instagram_icon from "../../../Assets/instagram_icon.svg";
// import linkedin_icon from "../../../Assets/linkedin_icon.svg";
// import twitter_icon from "../../../Assets/twitter_icon.svg";
// import { adminUrl } from "../../../constants";
import refer_img_background from "../../../../../Assets/referrals_img_background.svg";
import { useDispatch, useSelector } from "react-redux";
import { BiSolidCopyAlt } from "react-icons/bi";
import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const InviteFriends = ({ referralsDates, targetRef, values ,sectionNameForApproveAndReject,onClose}) => {
  const [copied, setCopied] = useState(false);
  // const textToCopy = "This is the text to copy!";

  const [showIcons, setShowIcons] = useState(false);
  const { customerLogin } = useSelector((state) => state?.customerLogin);
  console.log(customerLogin, "customerLogincustomerLogincustomerLogin");
  const handleButtonClick = () => {
    setShowIcons(!showIcons); // Toggle the visibility of social media icons
  };

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      // Reset copied status after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };




  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getReferralSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETREFERRALSSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "Referral Section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);


  return (
    <Box>
      <Box
        id="referpage"
        ref={targetRef}
        sx={{
          position: "relative", // This is key to make the image positioned relative to this container
          background: "#F7F7F7",
          background: "white",
          overflow: "hidden",
          padding: { xs: "50px 0px" },
        }}
      >
        <Container maxWidth="lg" sx={{ zIndex: 2 }}>
          <Grid container alignItems="center">
            {/* Left Section */}
            <Grid item xs={12} md={7}>
              <Box>
                <Typography
                  variant="h2"
                  textAlign="start"
                  sx={{
                    color: "#3B4056",
                    mb: 2,
                  }}
                >
                  {responseData?.heading || values?.title || "Default Heading"}
                  {/* Invite your Friends */}
                </Typography>
                <Typography
                  variant="body1"
                  textAlign="start"
                  sx={{
                    mb: 3,
                    lineHeight: "1.6",
                    color: "#7A7A7A",
                    maxWidth: "500px",
                  }}
                >
                  {responseData?.content || values?.content || "Default Sub-heading"}
                  {/* Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown */}
                </Typography>
                <Stack direction={{ xs: "column", md: "row" }}>
                  <Button
                    variant="outlined"
                    onClick={() => handleCopy(customerLogin?.data?.referral_code)}
                    sx={{
                      textTransform: "none",
                      color: "#7A7A7A",
                      padding: "0px 40px",
                      height: "35px",
                      borderColor: "white",
                      borderRadius: "23px",
                      background: "white",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    {/* {customerLogin?.data?.referral_code || */}
                    No refer code generate
                    {/* &nbsp; &nbsp;{" "}
                  <BiSolidCopyAlt
                    size={20}
                  // style={{
                  //     color: copied ? "green" : "#7A7A7A", // Green if copied, gray otherwise
                  //     transition: "color 0.3s ease-in-out", // Smooth transition for color
                  // }}
                  /> */}
                    {/* Animation for "Copied!" */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "30px",
                        opacity: copied ? 1 : 0,
                        transform: copied ? "translateY(0)" : "translateY(10px)",
                        transition: "all 0.3s ease-in-out",
                        color: "green",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      Copied!
                    </div>
                    {/* {referralsDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
                  </Button>
                  {/* {!showIcons && ( */}
                  <Button
                    variant="contained"
                    startIcon={
                      <FaShareAlt
                        style={{ color: "white", fontSize: "14px" }}
                      />
                    }
                    onClick={handleButtonClick}
                    sx={{
                      textTransform: "none",
                      color: "white",
                      padding: "20px 30px",
                      height: "35px",
                      borderRadius: "23px",
                      background: "#C38F51",
                      "&:hover": {
                        backgroundColor: "#C38F51",
                      },
                    }}
                  >
                    {responseData?.additional_data?.[0]
                      ?.primary_button_text || values?.primary_button_text || "Share Now"}
                  </Button>
                  {/* )} */}
                  {/* {showIcons && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 2,
                                        }}
                                    >
                                        {[facebook_icon, whatsapp_icon, instagram_icon, linkedin_icon, twitter_icon].map(
                                            (icon, index) => (
                                                <IconButton
                                                    key={index}
                                                    aria-label={`Social Icon ${index + 1}`}
                                                    sx={{
                                                        backgroundColor: "#C68A48",
                                                        color: "white",
                                                        padding: "12px",
                                                        height: "40px",
                                                        width: "40px",
                                                        "&:hover": {
                                                            backgroundColor: "#D9A766",
                                                        },
                                                    }}
                                                >
                                                    <img src={icon} alt={`Social Icon ${index + 1}`} />
                                                </IconButton>
                                            )
                                        )}
                                    </Box>
                                )} */}
                </Stack>
              </Box>
            </Grid>

            {/* Right Section */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  backgroundImage: `url(${refer_img_background})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  height: "350px",
                  // left:"200px",
                  left: "20%",

                  width: "100%",
                  display: { xs: "none", sm: "block" },
                  position: "relative",
                  zIndex: 0,
                }}
              >
                <img
                  src={`${adminUrl}${responseData?.additional_data?.[0]?.banner || values?.image}`}
                  // src={refer_img}
                  alt="Banner"
                  style={{
                    position: "absolute", // Make it relative to the parent `Box`
                    top: "10%", // Adjust as needed
                    left: "10%", // Adjust as needed
                    height: "270px",
                    zIndex: 1,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
    </Box >
  );
};

export default InviteFriends;
